module.exports = FloatingNavigationHelpers;